class @App.Components.Tabbox
  constructor: ->
    @$element = $('[data-component="tabbox"]')
    @$tabs = @$element.find('[data-tabpane]')
    @panes = $.map @$tabs, (i) -> document.getElementById $(i).data('tabpane')

    @showPane(@$tabs.first())

    @$element.on 'click', '[data-tabpane]', (e) =>
      e.preventDefault
      @showPane($(e.target))

  showPane: ($tab) =>
    $(@panes).hide()
    $('#' + $tab.data('tabpane')).fadeIn()
    @$tabs.removeClass('is-active')
    $tab.addClass('is-active')
    return

$ ->
  new App.Components.Tabbox
